import { render, staticRenderFns } from "./nigeria-lga-summary.vue?vue&type=template&id=004c192a&scoped=true&"
import script from "./nigeria-lga-summary.vue?vue&type=script&lang=js&"
export * from "./nigeria-lga-summary.vue?vue&type=script&lang=js&"
import style0 from "./nigeria-lga-summary.vue?vue&type=style&index=0&id=004c192a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c192a",
  null
  
)

export default component.exports